module.exports = __webpack_public_path__ + "static/media/right-arrow.54f0aa6f.svg";